/**
 * English: Hook to update device_settings (display_name) for a device.
 * Thai: Hook สำหรับอัปเดต device_settings (display_name) ของอุปกรณ์
 */
import { useState, useCallback } from 'react';
import { useApi } from './useApi';

export interface UpdateDeviceSettingsPayload {
  display_name: string | null;
}

export interface UseUpdateDeviceSettingsResult {
  updateDeviceSettings: (
    deviceDbId: number,
    payload: UpdateDeviceSettingsPayload
  ) => Promise<void>;
  updating: boolean;
  error: string | null;
  clearError: () => void;
}

export function useUpdateDeviceSettings(): UseUpdateDeviceSettingsResult {
  const api = useApi();
  const [updating, setUpdating] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const updateDeviceSettings = useCallback(
    async (deviceDbId: number, payload: UpdateDeviceSettingsPayload) => {
      setUpdating(true);
      setError(null);
      try {
        await api.put(`/api/devices/${deviceDbId}/settings`, payload);
      } catch (err) {
        const msg = err instanceof Error ? err.message : 'Unknown error';
        setError(msg);
        throw err;
      } finally {
        setUpdating(false);
      }
    },
    [api]
  );

  const clearError = useCallback(() => setError(null), []);

  return { updateDeviceSettings, updating, error, clearError };
}
